// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3jfZc","col":"styles_col__1kA55"};